module.exports = __webpack_public_path__ + "static/media/cross3.307e93bf.png";